import { state } from '../../../context/store'
import { Button, Text, Column, Image } from '../../Blocks';
import instructions from "../../../assets/Instructionwhite.webp";
import { closePopups } from '../../../utilities';

const ModalInstructions = ({ id }) => {


    return (

        <Column id={id} width="fit-content" gap="8px">
            <Image src={instructions} width="800px" dark />
            <Text>Swipe to rotate.</Text>
            <Text>Pinch to zoom.</Text>
            <Text mobileText="Swipe with two fingers to pan.">Swipe with two fingers to pan.</Text>
            <Button handleClick={(e) => closePopups(e)}>Go Back</Button>

        </Column>
    )
}

export default ModalInstructions
